import React, { FC } from 'react';

import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-helpers';

import { SUBSCRIPTION_STATUS } from '../../helpers/const';
import { Offering, offeringPropType } from '../../helpers/types';
import { PRICING_URL } from './helpers/const';
import {
  containerStyle,
  textNameStyle,
  textExpiredStyle,
  buttonStyle,
} from './helpers/styles';

interface TrialModalItemProps {
  userTrial: Offering;
}

const TrialModalItem: FC<TrialModalItemProps> = ({ userTrial }) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const { daysRemaining, offeringCategory, offeringCategoryName, status } =
    userTrial;

  const daysLeftText =
    daysRemaining > 1
      ? T.translate('MODAL_ITEM_TEXT_EXPIRED_COUNT_MULTIPLE', { daysRemaining })
      : T.translate('MODAL_ITEM_TEXT_EXPIRED_COUNT_SINGLE', { daysRemaining });

  return (
    <div css={containerStyle}>
      <div>
        <div css={textNameStyle}>{offeringCategoryName}</div>
        <div css={textExpiredStyle(daysRemaining)}>
          {status === SUBSCRIPTION_STATUS.ACTIVE
            ? daysLeftText
            : T.translate('MODAL_ITEM_TEXT_EXPIRED')}
        </div>
      </div>
      <Button
        data-testid="TrialModalItem_button"
        as="a"
        target="_blank"
        href={`${PRICING_URL}/${offeringCategory}`}
        style={buttonStyle}
        variant={Button.VARIANTS.PRIMARY}
      >
        {T.translate('MODAL_ITEM_TEXT_BUTTON_TEXT')}
      </Button>
    </div>
  );
};

TrialModalItem.displayName = 'TrialModalItem';
TrialModalItem.propTypes = {
  /** User Trial Data */
  userTrial: offeringPropType.isRequired,
};

export default TrialModalItem;
